import { memo } from 'react';

import { FormError } from '@components/form-error';
import { Stack } from '@components/stack';
import { useScopedTranslate } from '@locale/translate';

import { useFormContext } from './form-provider';

export const FormErrors = memo(() => {
  const {
    store: { useFormHasErrors, useHasSubmit },
  } = useFormContext();
  const hasErrors = useFormHasErrors();
  const hasSubmit = useHasSubmit();
  const { t } = useScopedTranslate(translations);

  if (!hasSubmit || !hasErrors) {
    return null;
  }

  return (
    <Stack space={0} align="flex-end">
      <FormError text={t('error')} />
    </Stack>
  );
});

const translations = {
  is: {
    error: 'Ekki tókst að senda formið þar sem það inniheldur villur',
  },
  en: {
    error: 'Unable to send the form as it contains errors',
  },
  dk: {
    error: 'Formularen kunne ikke sendes, da den indeholder fejl',
  },
};
